<template>
    <div>
        <div class="nav-icon" v-if="icon">
            <font-awesome-icon :icon="icon"></font-awesome-icon>
        </div>
        <div class="nav-title headline-font">
            {{ title }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: Array,
            default: () => [],
            required: false
        },
        title: {
            type: String,
            default: "",
            required: true
        }
    }
};
</script>
